<template>
    <div class="creategc spackage padding-20 bgc box-shadow" v-loading="loading">
        <section style="width: 811px;">
            <h1>基本信息</h1>
            <el-form :model="gcFormData" :rules="rules" ref="gcFormData" label-width="100px" class="starmgt-form">
                <el-form-item label="商品名称" prop="name">
                    <el-input v-model="gcFormData.name" placeholder="请输入商品名称，不超过40个字" maxlength="40" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="商品分类" prop="catecode">
                    <el-select v-model="gcFormData.catecode" placeholder="请选择商品分类" :loading="loadingStatus">
                        <el-option v-for="item in gcClassify" :label="item.name" :value="item.innerid" :key="item.label"></el-option>
                    </el-select>
                    <span class="add_classify" @click="jumpToList">添加分类</span>
                </el-form-item>

                <el-form-item label="商品图片" prop="logoatturlid" class="upload-image" required>
                    <div class="upload">
                        <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                    </div>
                   <div class="position">
                       <!-- <el-button plain>选择文件</el-button> -->
                       <p>建议尺寸350*350px的JPG、PNG格式，不超过2M</p>
                   </div>
                </el-form-item>

                <el-form-item label="商品价格" prop="saleprice" style="margin-top: 10px">
                    <el-input v-model="gcFormData.saleprice" style="width: 200px;" placeholder="请输入商品的价格"></el-input>
                </el-form-item>

                <el-form-item label="划线价格" prop="uprice" style="margin-top: 10px">
                    <el-input v-model="gcFormData.uprice" style="width: 200px;" placeholder="请输入商品的划线价格"></el-input>
                </el-form-item>

                <el-form-item label="商品库存" prop="stockcount" style="margin-top: 10px" required>
                    <el-input v-model="gcFormData.stockcount" style="width: 200px;" placeholder="请输入商品库存"></el-input>
                </el-form-item>

                <el-form-item label="每单限购量" prop="limitcountbyorder" style="margin-top: 10px" required>
                    <el-input v-model="gcFormData.limitcountbyorder" style="width: 200px;" placeholder="请输入每单限购量"></el-input>
                </el-form-item>

                <el-form-item label="商品详情">
                    <!-- <el-input type="textarea" v-model="gcFormData.stardesp" placeholder="请简要描述该星球（200字以内）" maxlength="200" show-word-limit></el-input> -->
                    <div class="ueditorBox" prop="materialdesp">
                        <uEditor :content="gcFormData.materialdesp" ref="uEditor" @getUEditorContent="getMsgContent"></uEditor>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button @click="$router.back(-1)">取消</el-button>
                    <el-button v-if="type !== 'delete'" type="primary" @click="submitForm('gcFormData')" style="margin-left: 20px;">提交</el-button>
                </el-form-item>
            </el-form>
        </section>
        <!-- <div>111</div> -->

        <!-- 添加分类 弹窗 -- start -->
        <el-dialog title="编辑分类" :visible.sync="dialogFormVisible" @close="cancelCE" class="create_edit_dialog">
            <el-form :model="formData" :rules="rules" ref="formData">
                <el-form-item label="分类名称" :label-width="formLabelWidth" prop="name">
                    <el-input type="text" v-model="formData.name" minLength="1" maxLength="8" autocomplete="off" placeholder="输入分类名称，不超过8个字" class="textStyle"></el-input>
                </el-form-item>
            </el-form>
            <el-form :model="form">
                <el-form-item label="分类说明" :label-width="formLabelWidth" prop="memo">
                    <el-input type="textarea" :rows="4" v-model="formData.memo" maxLength="80" autocomplete="off" placeholder="输入分类说明，不超过80个字" class="textStyle"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelCE">取 消</el-button>
                <el-button type="primary" @click="sureAdd()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 添加分类 弹窗 -- end -->

    </div>
</template>

<script>
import {getMaterialsInfo, getMaterialCategory, saveOrUpdateMaterials, saveOrUpdateMaterialCategory } from '@/api/cPurchaseApi'
import Upload from 'base/upload/upload'
import UploadFile from 'base/upload/uploadFile'
import UEditor from 'base/uEditor/uEditor2'
import {mapActions} from 'vuex'
import {getCookie,formatFileInfo} from '@/common/js/tools'
import $ from 'jquery'

export default {
    name: "CreateGM",
    data() {
        let validatelogodata = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请商品图片'))
            } else {
                callback()
                if(value.furl) {
                    this.gcFormData.logodata = value.furl
                }
            }
        }
        return {
            form: {},
            loading: false,
            token: getCookie('token'), // token
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            innerid: this.$route.query.innerid ? this.$route.query.innerid : '',
            type: this.$route.query.type,
            imgUrl: "http://img.capwhale.com/mp/bg/", // 服务器头像图片url
            gcClassify: [],
            imageUrl: '',
            gcFormData:{
                name: '',
                catecode: '',
                catename: '',
                materialdesp: '',
                saleprice: '',
                uprice: '',
                logoattid: '',
                logoatturlid: '',
                stockcount: '',
                limitcountbyorder: ''
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: '',
                height: ''
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            rules: {
                name: [
                    { required: true, message: '请输入商品名称', trigger: 'blur' }
                ],
                catecode: [
                    { required: true, message: '请选择商品分类', trigger: 'blur' }
                ],
                logodata: [
                    {validator: validatelogodata, message: '请上传商品图片', required: true, trigger: 'change'}
                ],
                saleprice: [
                    { required: true, message: '请输入商品价格', trigger: 'change' }
                ],
                stockcount: [
                    { required: true, message: '请输入商品库存', trigger: 'blur' }
                ],
                limitcountbyorder: [
                    { required: true, message: '请输入每单限购量', trigger: 'blur' }
                ]
            },
            updateImgStatus: false,  // 更改图片操作状态 true 更改 false 未更改
            dialogFormVisible: false,
            formData:{
                name: '',
                memo: ''
            },
            formLabelWidth: '80px',
            loadingStatus: true
        }
    },
    mounted() {
        this.getGCList()
        if (this.innerid) {
            this.getGMInfo()
        }
    },
    methods: {
        // 获取商品分类列表
        getGCList() {
            getMaterialCategory({
                success: data => {
                    this.loadingStatus = false
                    let resData = data.data
                    this.gcClassify = resData
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        // 获取商品分类信息
        getGMInfo() {
            let data = {
                innerid: this.innerid
            }
            this.setLoading(true)
            // 获取商品素材信息
            getMaterialsInfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    let resData = data.data
                    this.gcFormData.name = resData.name
                    this.gcFormData.catecode = resData.catecode

                    this.gcFormData.logoatturlid = resData.logoatturlid
                    this.gcFormData.logoattid = resData.logoattid

                    this.gcFormData.saleprice = resData.saleprice
                    this.gcFormData.uprice = resData.uprice
                    this.gcFormData.limitcountbyorder = resData.limitcountbyorder
                    this.gcFormData.stockcount = resData.stockcount
                    this.gcFormData.materialdesp = resData.materialdesp
                    this.$refs.uEditor.init(this.gcFormData.materialdesp)

                    // 设置图片回填
                    this.$refs.coverfile.setImage(this.gcFormData.logoatturlid)
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        // 添加分类
        jumpToList() {
            // this.$router.push({ name: 'goodsCategory', query: {}})
            this.dialogFormVisible = true
        },

        // 取消创建
        cancelCE() {
            this.dialogFormVisible = false
            this.formData.name = ''
            this.formData.memo = ''
        },

        // 新增分组 接口调用
        sureAdd() {
            this.setLoading(true)
            let data = {
                name: this.formData.name,
                memo: this.formData.memo
            }
            saveOrUpdateMaterialCategory({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.dialogFormVisible = false
                    this.formData.name = ''
                    this.formData.memo = ''
                    this.$message.success('分组添加成功!')
                    this.getGCList()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },

        // 商品详情
        getMsgContent(content) {
            this.gcFormData.materialdesp = content
        },
        
        updateimg() {
            let reads = new FileReader(),
                file = document.getElementById('file').files[0],
                isJPG,
                $this = this
            const isLt2M = file.size / 1024 / 1024 < 2;
            if(file.type === 'image/jpeg' || file.type === 'image/png') {
                isJPG = true
            } else {
                isJPG = false
            }

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 jpg/png 格式!')
                return false
            }

            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!')
                return false
            }

            reads.readAsDataURL(file);

            reads.onload = function(){

                $this.gcFormData.logodata = $this.imageUrl = this.result
                // 重置头像
                $("input[name=headerimg]:checked").prop('checked',false)
            }
        },

        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let updata = JSON.parse(JSON.stringify(this.gcFormData))
                    updata.innerid = this.innerid
                    for (let item in this.gcClassify) {
                        if (this.gcClassify[item].innerid === updata.catecode) {
                            updata.catename = this.gcClassify[item].name
                        }
                    }
                    console.log(updata)
                    this.setLoading(true)
                    saveOrUpdateMaterials({
                        data: updata,
                        success: data => {
                            this.$message.success('保存成功')
                            this.setLoading(false)
                            this.$router.back()
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false;
                }
            });
        },

        // 设置图片信息（本地）
        setCoverfile(img) {
            console.log(img)
            // 发生头像图片变更操作
            this.updateImgStatus = true

            $("input[name=headerimg]:checked").prop('checked',false)    // 清除选中头像
            // this.gcFormData.logodata = img
            this.gcFormData.logoatturlid = img.furl
            this.gcFormData.logoattid = img.key
            
        },

        ...mapActions([
            'setLoading'
        ])
    },
    
    components: {
        Upload,
        UploadFile,
        UEditor
    }
}
</script>

<style lang="scss" type="text/scss"  rel="stylesheet/scss">
    .creategc {
        .create_edit_dialog {
            .el-dialog {
                width: 550px;
                height: 350px;
            }
            .el-dialog__body {
                padding: 20px 20px 0 20px;
            }
            .el-dialog__footer {
                padding: unset;
            }
            .el-input,
            .el-input__inner {
                width: 420px;
            }
            .el-textarea textarea {
                width: 420px;
                height: 130px;
                resize: none;
            }
        }
        .add_classify {
            font-size: 14px;
            color: #409EFF;
            margin-left: 15px;
            cursor: pointer;
        }
        .headerimg {
            margin-right: -10px;
            label {
                position: relative;
                display: inline-block;
                cursor: pointer;
                margin-right: 10px;
                margin-bottom: 10px;
                width:110px;
                height:65px;
                box-sizing: border-box;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            input[type=radio]:checked + label {
                border: solid 1px #409EFF;
            }

            input[type=radio]:checked + label:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                width: 23px;
                height: 23px;
                background: url("../../../common/images/starMgtHeaderimg/radio.png") no-repeat center ;
                background-size: 23px;
            }
            .btn {
                margin-top: 20px;
                text-align: center;
            }
        }
        h1 {
            margin: 20px 0;
            padding-left: 8px;
            color: #303133;
            font-weight: 500;
            font-size: 16px;
            border-left: solid 2px #409EFF;
        }
        .el-input__prefix, .el-input__suffix {
            height: auto;
        }
        .el-form-item__label {
            text-align: left;
        }
        .upload {
            float: left;
            margin-right: 15px;
        }
        .idcardImage .avatar-uploader{
            box-sizing: border-box;
            width: 170px;
            height: 170px;
        }

        .avatar {
            width: 212px;
            height: 126px;
            display: block;
        }

        .el-textarea textarea {
            height: 105px;
        }

        .position {
            margin-top: 45px;
            p {
                color: #C0C4CC;
                font-size: 14px;
            }
        }

        .switch-text,
        .el-switch {
            float: left;
        }
        .el-switch {
            margin-top: 10px;
        }
        .switch-text p {
            margin-left: 20px;
            color: #909399;
            font-size: 14px;
        }
        .avatar-uploader .el-upload {
            width: 130px;
            height: 130px;
            border: 1px dashed #d9d9d9;
            border-radius: unset;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .icon_upload:before {
            background-size: 30%;
            background-position: center;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 212px;
            height: 126px;
            line-height: 178px;
            text-align: center;
        }
    }
</style>
